<template>
  <div id="myFrom">
    <div id="title">新增会员</div>
    <div id="fromContent"></div>
  </div>
</template>

<script>
  export default {
    name: "MyFrom"
  }
</script>

<style scoped>
  #myFrom{
    margin: 15px;
    margin-left: 215px;
    background-color: #fff;
  }

  #title{
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid #d1d4d7;
    padding-left: 1.25rem;
    font-size: 0.875rem;
    background-color: #f8f9fa;
    color: #2a2c36;
  }

  #fromContent{
    padding: 15px;
    font-size: 0.875rem;
    line-height: 1.4;
  }
</style>
